import React from "react";
import { Pill as StyledPill } from "../styles";

const Pill = ({ children, tone = "a" }) => {
  return <StyledPill tone={tone}>{children}</StyledPill>;
};

export default Pill;
